import { SharedState } from '@trello/shared-state';

export interface FilteredCardsCountState {
  count: number;
  isLoading: boolean;
}

/**
 * Shared state that keeps track of how many cards are currently visible to the
 * user, given filter status. Single board views and multi board views calculate
 * this value differently (client-side vs network response), and this saves us
 * an API call for SBVs.
 */
export const filteredCardsCountState = new SharedState<FilteredCardsCountState>(
  {
    count: 0,
    isLoading: false,
  },
);
